let language = {
    "PAYMENTS-DASHBOARD-ALERT-DOWNLOAD-TITLE": "下载发票",
    "PAYMENTS-DASHBOARD-ALERT-DOWNLOAD-CONTENT": "未找到该订单的发票信息！",
    "PAYMENTS-DASHBOARD-ALERT-DOWNLOAD-CONTENT-LIST": "未找到以下发票信息",
    "PAYMENTS-DASHBOARD-ALERT-DOWNLOAD-CONTENT-EMPTY": "未选择任何项目",
    "PAYMENTS-DASHBOARD-PROOFING-ORDER-NONSUPPORT-INVOICE-DOWNLOADS":"打样订单不支持下载发票。"
};

export { language }
